import * as React from 'react';
declare const I18n;

import { Resource } from '../../../../types';
import CardItem from '../../../resource_category/components/card_item';

type Props = {
  initialData: {
    resources: Resource[],
    userType?: string,
  }
}

const IndexResource: React.FunctionComponent<Props> = ({
  initialData: {
    resources,
    userType,
  } }: Props): JSX.Element => {
  const [resourceList, setResourceList] = React.useState(resources);

  const handleDelete = (id) => {
    //Delete not implemented for resources dashboard view
  }

  return (
    <div className="resources_index">
      <div className="courses_index__list">
      {
        resourceList.length > 0 ? (
          <>
            {
              resourceList.map((row, index) => (
                <CardItem
                  cardBackground='primary'
                  title='{row.title}'
                  description={row.description || ''}
                  targetRole={row.target_role || 'all'}
                  id={row.id}
                  index={index}
                  key={row.id}
                  image={row.image_url}
                  handleDelete={handleDelete}
                  isFacilitator={userType === 'Facilitator'}
                  isLearner={userType === 'Learner'}
                  type={row.resource_type || 'PDF'}
                  duration={row.duration || '10 min'}
                  category={row.category_name || 'General'}
                  url={row.url}
                />
              ))
            }
          </>
        ) : (
          <div className="courses_index__empty-state app-text">
            {I18n.t('models.resource.messaging.none_available')}
          </div>
        )
      }
      </div>
    </div>
  );
}

export default IndexResource;